import React from "react";
import { Box, Typography, Button, Paper, Fade, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ChatBubbleTwoToneIcon from "@mui/icons-material/ChatBubbleTwoTone";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const EmptyChatState = ({ onStartNewChat }) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const primaryDark = theme.palette.primary.dark;
  return (
    <Fade in timeout={800}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          bgcolor: "#ffffff",
          textAlign: "center",
          p: 3,
        }}
      >

        {/* Main Icon Container */}
        <Box sx={{ position: "relative", mb: 2.5 }}>
          <Paper
            elevation={0}
            sx={{
              width: 88,
              height: 88,
              borderRadius: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
              boxShadow: `0 16px 32px -8px ${alpha(primaryColor, 0.35)}`,
              transform: "rotate(-5deg)",
              position: "relative",
              zIndex: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "rotate(-5deg) scale(1.05)",
                boxShadow: `0 20px 40px -8px ${alpha(primaryColor, 0.4)}`,
              },
            }}
          >
            <ChatBubbleTwoToneIcon
              sx={{ fontSize: 40, color: "#fff", opacity: 0.95 }}
            />
          </Paper>

          {/* Decorative Badge */}
          <Box
            sx={{
              position: "absolute",
              bottom: -6,
              right: -6,
              width: 36,
              height: 36,
              borderRadius: "10px",
              bgcolor: primaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 8px 16px -4px ${alpha(primaryColor, 0.4)}`,
              transform: "rotate(15deg)",
              zIndex: 3,
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "rotate(15deg) scale(1.1)",
              },
            }}
          >
            <AutoAwesomeIcon sx={{ color: "#fff", fontSize: 16 }} />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontWeight: 700,
            color: "#1e293b",
            mb: 1,
            fontSize: "1.25rem",
            letterSpacing: "-0.02em",
          }}
        >
          Select a conversation
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            color: "#64748b",
            maxWidth: 340,
            mb: 2.5,
            lineHeight: 1.6,
            fontSize: "0.82rem",
          }}
        >
          Pick a contact from your list to start a conversation or view your message history.
        </Typography>

        {/* Start New Chat Button */}
        <Button
          variant="contained"
          disableElevation
          onClick={onStartNewChat}
          sx={{
            px: 3,
            py: 1,
            borderRadius: "10px",
            bgcolor: primaryColor,
            color: "#fff",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            boxShadow: `0 4px 14px ${alpha(primaryColor, 0.35)}`,
            transition: "all 0.3s ease",
            "&:hover": {
              bgcolor: primaryDark,
              boxShadow: `0 6px 20px ${alpha(primaryColor, 0.45)}`,
              transform: "translateY(-2px)",
            },
            "&:active": {
              transform: "translateY(0)",
            },
          }}
        >
          Start New Chat
        </Button>
      </Box>
    </Fade>
  );
};

export default EmptyChatState;
